<div class="md-form" *ngIf="vm">

    <input *ngIf="vm.type != 'textarea'" [type]="vm.htmlType" class="form-control" [id]="vm.elementId" [name]="vm.elementId" [disabled]="vm.isLocked"
        #input_ref="ngModel" #input [required]="vm.isRequired" [minlength]="vm.minLength" [readonly]="vm.isLocked"
        [ngModel]="text" (ngModelChange)="modelChanged($event)" [ngModelOptions]="{standalone: true}"
        [attr.autocomplete]="inputAutocomplete"
        (keydown)="keyDown($event)"
        (keyup.enter)="keyUpEntered($event)" mdbInput>

    <textarea *ngIf="vm.type == 'textarea'" type="text" class="md-textarea md-textarea-auto form-control" [id]="vm.elementId" [disabled]="vm.isLocked"
        [ngModel]="text" (ngModelChange)="modelChanged($event)" [readonly]="vm.isLocked"                        
        [ngModelOptions]="{standalone: true}" mdbInput></textarea>


    <ng-template #helpTemplate>
        <div>
            <span>{{vm.helpText || vm.title}}</span>
        </div>
        <div *ngIf="validationErrors.length">
            <p class="text-danger" *ngFor="let ve of validationErrors">{{ve}}</p>
        </div>
    </ng-template>

    <!-- [mdbPopoverHeader]="vm.title" [mdbPopover]="popTemplate" -->
   <label [for]="vm.elementId" [ngStyle]="{ cursor: (vm.title && !vm.hideLabel) ? 'pointer' : 'inherited'}" 
        [mdbTooltip]="helpTemplate"
        [triggers]="(vm.title && !vm.hideLabel) ? 'hover' : ''">{{vm.title}}
        <mdb-icon *ngIf="validationErrors.length" class="text-danger" fas icon="exclamation-circle"></mdb-icon>
        <mdb-icon *ngIf="vm.isLocked" style="color: #e0e0e0;" fas icon="lock"></mdb-icon>
        <mdb-icon *ngIf="vm.helpText" fas icon="question-circle" class="icon-help"></mdb-icon>
    </label>

</div>